import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { MouseInput } from '../../../platform/input/MouseInput';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ToolBehavior } from '../../canvas/tooling/ToolBehavior';
import { toolReset } from '../../canvas/tooling/ToolCommands';
import { resolve } from '../../Container';

export class InstantDequipBehavior extends ToolBehavior {

    @resolve(CommandDispatcher) private dispatch: CommandDispatcher;

    public onMouseUp(state: string, e: MouseInput): string | void {
        this.dispatch(toolReset);
    }
}

export const objectTool = defineToolWithCommonBehaviors({
    id: 'objectTool',
    label: 'Insert Tool',
    category: 'design',
    icon: 'deqo://icons/hero/plus-circle',
    weight: 5010,
    // shortcut: 'S',
    behaviors: [InstantDequipBehavior]
});

